import { CloudOff, Loader2, RefreshCw, Wifi, WifiOff } from 'lucide-react';
import { useSyncStore } from '@/store/syncStore';
import { requestSyncPause, syncNow } from '@/offline';

export default function SyncModeBanner() {
  const mode = useSyncStore((s) => s.posSyncMode);
  const pending = useSyncStore((s) => s.pendingQueueCount);
  const failed = useSyncStore((s) => s.failedQueueCount);
  const isSyncing = useSyncStore((s) => s.isSyncing);
  const progress = useSyncStore((s) => s.syncProgress);
  const reachable = useSyncStore((s) => s.isServerReachable);
  const online = useSyncStore((s) => s.isOnline);

  if (mode === 'Live Online') return null;

  const isManual = mode === 'Offline Always Manual Sync';
  const label = isManual ? 'Offline Always' : 'Local First';
  const showAmber = !reachable || !online;

  return (
    <div
      className={`flex flex-wrap items-center gap-2 px-3 py-1.5 text-xs border-b ${
        showAmber
          ? 'bg-amber-50 border-amber-200 text-amber-900'
          : 'bg-slate-50 border-slate-200 text-slate-700'
      }`}
    >
      {showAmber ? <WifiOff className="w-3.5 h-3.5" /> : reachable ? <Wifi className="w-3.5 h-3.5" /> : <CloudOff className="w-3.5 h-3.5" />}
      <span className="font-medium">{label}</span>
      <span className="text-gray-500">·</span>
      <span>
        {pending} pending{failed ? ` · ${failed} failed` : ''}
      </span>
      {isSyncing && progress && (
        <span className="inline-flex items-center gap-1 text-primary-700">
          <Loader2 className="w-3 h-3 animate-spin" />
          Syncing {progress.done} / {progress.total}
          {progress.failed ? ` · failed ${progress.failed}` : ''}
        </span>
      )}
      <div className="ml-auto flex items-center gap-2">
        {isSyncing ? (
          <button
            type="button"
            onClick={() => requestSyncPause()}
            className="px-2 py-0.5 rounded border border-gray-300 bg-white hover:bg-gray-50"
          >
            Pause
          </button>
        ) : (
          <button
            type="button"
            onClick={() => void syncNow()}
            disabled={!reachable}
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded border border-primary-300 bg-primary-50 text-primary-800 hover:bg-primary-100 disabled:opacity-50"
          >
            <RefreshCw className="w-3 h-3" />
            Sync Now
          </button>
        )}
      </div>
    </div>
  );
}
